import { useDisclosure } from './useDisclosure'

export const useFilePreview = () => {
  const filePreview = useDisclosure(false)

  return { filePreview }
}
